import DirhamSymbolSvg from '@assets/images/svg/dirham-symbol.svg';
import React from 'react';
import { View } from 'react-native';

export interface DirhamSymbolIconProps {
    size?: number;
    color?: string;
}

/** New UAE Dirham currency symbol — used in place of the "AED" text. */
export function DirhamSymbolIcon({ size = 13, color = '#4D4D4D' }: Readonly<DirhamSymbolIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <DirhamSymbolSvg width={size} height={size} color={color} />
        </View>
    );
}

export default DirhamSymbolIcon;
